'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);

/**
 *
 * @desc Hook that detects clicks outside of a given element.
 * @param {*} elementRefs
 * @param {*} callback
 *
 */

var useClickOutside = function useClickOutside(elementRefs, callbackClickOutside) {
  React.useEffect(function () {
    var handleClick = function handleClick(event) {
      var elRefs = Array.isArray(elementRefs) ? elementRefs : [elementRefs];
      if (!elRefs.length) {
        return;
      }

      // Checking `current` first so we can be backwards compatiable with refs
      var elementRef = elRefs.find(function (elRef) {
        var _element;
        var element = elRef;
        if (element && 'current' in element) {
          element = element.current;
        }
        return (_element = element) === null || _element === void 0 ? void 0 : _element.contains(event.target);
      });
      if (!elementRef) {
        callbackClickOutside(event);
      }
    };
    window.addEventListener('click', handleClick, true);
    return function () {
      window.removeEventListener('click', handleClick, true);
    };
  }, [elementRefs, callbackClickOutside]);
};

module.exports = useClickOutside;
